import React, { useEffect } from "react";

import DealerDetails from "../../components/admin/Dealer-Details";




const DealerDetailsPage = () => {

    useEffect(() => {
        document.body.id = "dealerdetailsPage-002";
      }, []);

  return (
    <div>
   <DealerDetails />
    </div>
  );
};

export default DealerDetailsPage;
